import { render } from "./form-maintenance-link-box.vue?vue&type=template&id=64155194&scoped=true"
import script from "./form-maintenance-link-box.vue?vue&type=script&lang=js"
export * from "./form-maintenance-link-box.vue?vue&type=script&lang=js"

import "./form-maintenance-link-box.vue?vue&type=style&index=0&id=64155194&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64155194"],['__file',"src/components/notepad/form-maintenance/form-maintenance-link-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64155194"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64155194', __exports__)) {
    api.reload('64155194', __exports__)
  }
  
  module.hot.accept("./form-maintenance-link-box.vue?vue&type=template&id=64155194&scoped=true", () => {
    api.rerender('64155194', render)
  })

}


export default __exports__